import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-us',
  imports: [TranslateModule],
  templateUrl: './us.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './us.component.css'
})
export class UsComponent {}
